import React from 'react';
import classNames from 'classnames';

export const CardView = ({
  className,
  children,
  containerRef = undefined,
  disableFullHeight = false,
  cardStyle= null,
}) => {
  const refObj = containerRef ? { ref: containerRef } : {};
  return (
    <div
      className={classNames(
        'min-w-0 bg-white shadow border border-border-light rounded p-4 flex flex-col items-stretch justify-start',
        className,
        { 'h-full': !disableFullHeight }
      )}
      {...refObj}
      style={cardStyle}
    >
      { children }
    </div>
  );
}

export default CardView;
